import React from 'react'

import styles from './ErrorMessage.module.css'

interface ErrorMessageProps {
  message: string
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => (
  <aside className={styles.errorMessage}>{message}</aside>
)

export default ErrorMessage
